import React from 'react';
import styles from './styles.module.scss';

interface MarketingConsentProps {
  value: boolean | null;
  onChange: (value: boolean) => void;
}

/**
 * Consenso marketing Enpal — sempre visibile sopra la CTA della slide telefono.
 * Lo stato resta tri-state (null = nessuna scelta): una mancata risposta viene
 * registrata come "No" senza bloccare l'invio della richiesta.
 */
const MarketingConsent: React.FC<MarketingConsentProps> = ({ value, onChange }) => {
  return (
    <div className={styles.consentCard}>
      <h4 className={styles.title}>Consensi facoltativi</h4>
      <p className={styles.intro}>
        Facoltativi: puoi rispondere oppure lasciare vuoto. Se non rispondi,
        verranno registrati come « No ». Il preventivo lo ricevi comunque.
      </p>

      <div className={styles.question}>
        <h5 className={styles.questionTitle}>Comunicazioni commerciali Enpal</h5>
        <p className={styles.questionDescription}>
          Acconsento a ricevere da Enpal Italia S.r.l. offerte e novità su
          fotovoltaico, batterie e pompe di calore, via email, SMS, WhatsApp e
          telefono.
        </p>
        <p className={styles.questionNote}>
          Serve solo per i contatti successivi: senza questo consenso ti
          chiamiamo comunque per la richiesta che hai appena fatto.
        </p>

        <div className={styles.choiceRow}>
          <button
            type="button"
            className={`${styles.choiceBtn} ${value === true ? styles.selected : ''}`}
            onClick={() => onChange(true)}
            aria-pressed={value === true}
          >
            <span className={styles.radioDot} />
            Sì, acconsento
          </button>
          <button
            type="button"
            className={`${styles.choiceBtn} ${value === false ? styles.selected : ''}`}
            onClick={() => onChange(false)}
            aria-pressed={value === false}
          >
            <span className={styles.radioDot} />
            No, grazie
          </button>
        </div>
      </div>
    </div>
  );
};

export default MarketingConsent;
